import { render, staticRenderFns } from "./ApriaSitiosRamsar.vue?vue&type=template&id=3709bbc8&scoped=true&lang=pug"
import script from "./ApriaSitiosRamsar.vue?vue&type=script&lang=js"
export * from "./ApriaSitiosRamsar.vue?vue&type=script&lang=js"
import style0 from "./ApriaSitiosRamsar.vue?vue&type=style&index=0&id=3709bbc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3709bbc8",
  null
  
)

export default component.exports